import { byPrefixAndName } from '@awesome.me/kit-5c288c4b3f/icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { classNames } from '../utils'
import { StatProps } from '../types'

export const Stat = ({
  iconType,
  iconName,
  statNumber,
  statDescription,
}: StatProps) => {
  return (
    <div className="mt-8 flex gap-4 md:mt-2">
      <div
        className={classNames(
          'flex h-24 w-24 items-center justify-center rounded-full bg-gradient-to-br from-primary-900 to-primary-500'
        )}
      >
        <FontAwesomeIcon
          className="text-default-50"
          size="2x"
          icon={byPrefixAndName[iconType][iconName]}
        />
      </div>
      <div className="flex flex-col justify-center">
        <h3 className={classNames('text-3xl text-default-50')}>{statNumber}</h3>
        <p className={classNames('text-2xl text-default-50')}>
          {statDescription}
        </p>
      </div>
    </div>
  )
}
